export enum SesionDocumentType {
    Dokument = 1,
    DodatniMaterijalObavijest = 2
}